import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AiOutlineArrowLeft } from "react-icons/ai";
import Icon from "../components/Icon";
import Logo from "../assets/logo.png";

const Unauthorized = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds((s) => s - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      navigate("/home");
    }, 5000);

    return () => {
      clearInterval(countdown);
      clearTimeout(redirect);
    };
  }, [navigate]);

  return (
    <Container fluid className="vh-100">
      <Row className="h-100">
        <Col
          xs={12}
          md={5}
          className="d-flex align-items-center justify-content-center"
        >
          <div className="text-center py-5">
            <img
              src={Logo}
              alt="Logotipo de la empresa"
              className="img-fluid mb-4"
              style={{ maxWidth: "200px" }}
            />
            <h1 className="display-1 fw-bold text-danger">401</h1>
            <h2 className="h3 text-gray-800 mb-4">Acceso no autorizado</h2>
            <p className="text-muted mb-4">
              No tienes permisos para acceder a esta página. Redirigiendo en{" "}
              {seconds} s...
            </p>
            <Link to="/home">
              <Button variant="outline-primary" size="lg">
                <AiOutlineArrowLeft className="me-2" />
                Regresar al inicio
              </Button>
            </Link>
          </div>
        </Col>

        <Col
          xs={12}
          md={7}
          className="d-flex justify-content-center align-items-center"
        >
          <Icon icon="block" size={500} className="text-red-700" />
        </Col>
      </Row>
      <footer className="text-muted small text-center">
        Copyright © ODT 2023 - Todos los derechos reservados
      </footer>
    </Container>
  );
};

export default Unauthorized;
